import moment from "moment"
import remark from "remark"
import remarkHTML from "remark-html"

const getDaysToExpiry = expiryDate => {
  const today = moment()
  const expiry = moment(expiryDate, "YYYY-MM-DD")

  return expiry.diff(today, "days")
}

export const upcomingEventsFilter = ({ node }) => {
  if (
    moment(node.end.local).isBefore(moment()) ||
    node.status === "canceled" ||
    node.status === "completed" ||
    node.status === "draft"
  ) {
    return false
  }

  return true
}
export default {
  upcomingEventsFilter,
}

export const formatMarkdownToHtml = (value, openLinksInNewTab = false) => {
  const html = remark()
    .use(remarkHTML)
    .processSync(value)
    .toString();

  if (!openLinksInNewTab) return html;

  return html.replace(/<a /g, '<a target="_blank" rel="noopener noreferrer" ');
};

export const isBrowser = typeof window !== "undefined" && window

// Helper function to process items with expiry logic
export const processItemsWithExpiry = (items, orderData) => {
  const productIds = orderData.products.map(product => product.id)

  const processedItems = [...items]
    .filter(item => productIds.includes(item.dataShopifyId))
    .map(item => {
      const itemOrder = orderData.products.find(
        p => p.id === item.dataShopifyId
      )

      if (!itemOrder) {
        return item
      }

      // Check if it has an `dataExpiryDate` or `dataExpiryDuration`
      if (!item.dataExpiryDate && !item.dataExpiryDuration) {
        return item
      }

      let daysToExpire = -1

      // If `dataExpiryDate` is set, check if it is after today
      if (item.dataExpiryDate) {
        const expiryDate = moment(item.dataExpiryDate, "YYYY-MM-DD")
        daysToExpire = getDaysToExpiry(expiryDate)
      } else if (item.dataExpiryDuration) {
        // If `dataExpiryDuration` is set, add the number of days from the order created date
        const expiryDuration = Number(item.dataExpiryDuration)
        const orderDate = moment(itemOrder.date, "YYYY-MM-DD").add(1, "days")

        // Add the duration to the order date
        const expiryDate = orderDate.add(expiryDuration, "days")
        daysToExpire = getDaysToExpiry(expiryDate)
      }

      return {
        ...item,
        dataDaysToExpire: daysToExpire,
        tag:
          daysToExpire >= 0
            ? {
              label: `${daysToExpire} days left`,
              color: daysToExpire < 7 ? "red" : "white",
            }
            : undefined,
      }
    })
    .filter(item =>
      typeof item.dataDaysToExpire !== "undefined"
        ? item.dataDaysToExpire >= 0
        : true
    )
    .sort((a, b) => a.dataDaysToExpire - b.dataDaysToExpire)

  // Get expired items
  const expiredItems = items
    .filter(item => productIds.includes(item.dataShopifyId))
    .filter(item => !processedItems.find(p => p.title === item.title))

  return {
    active: processedItems,
    expired: expiredItems,
  }
}
